import { addChapterUrlParam } from './articleListedChapterUrlParam';
import { articleListedState as state } from './articleListedState';
import { reload } from './articleListedHandlers';
import { chapeterSelectors } from './articleListedElements';

export const articleListedSelect = (): void => {
  if (!chapeterSelectors) return;

  chapeterSelectors.forEach((chapterSelectElement) => {
    chapterSelectElement.addEventListener('change', (event) => {
      const target = event.target as HTMLSelectElement;
      const selectedSection = Number(target.value);

      if (!isNaN(selectedSection)) {
        addChapterUrlParam(selectedSection);
        state.setActiveChapter(selectedSection);
        reload();
      } else {
        throw new Error('Vybraná hodnota sekce není platné číslo');
      }
    });
  });
};
